import {
  GenericServerResponse,
  User
  } from '@tendercuts/models';


export interface UserState {

  user: User;
  loading: boolean;
  error: boolean;
  errorMessage: string;
  genericServerResponse: GenericServerResponse;
}

export const userInitialState = {
  user: null,
  loading:  false,
  error: false,
  errorMessage: null,
  genericServerResponse: null
};
export function userTestState() {
  return {
    user: null,
    loading:  false,
    error: false,
    errorMessage: null,
    genericServerResponse: null
  }
};